import React from "react";

export default function Jaculatorias() {
  return (
    <>
      Sacratísimo Corazón Eucarístico de Jesús <br /> <i>En Vos Confío</i> <br /> <br />
      Inmaculada Madre Del Divino Corazón Eucarístico de Jesús <br /> <i>Ruega por Nosotros</i>
    </>
  );
}
